<template>
  <b-modal
    id="EntityPlanModal"
    class="popover-modal"
    hide-header
    hide-footer
    no-close-on-esc
    no-close-on-backdrop
    @hide="refreshPage"
    ref="EntityPlanModal"
  >
    <div class="text-center">
      <div>
        <p class="vp-font-weight-700 vp-font-size-17 header-font">
          Package changed
        </p>
      </div>

      <div class="vp-width-416">
        <p class="vp-font-size-16 content">
          Your package has been changed to <b>“{{ entityPlan }}”</b> plan.
          Contact our customer service team at
          <a href="mailto:cs@lamasatech.com" class="contact_email">cs@lamasatech.com</a> for more
          information.
        </p>
      </div>

      <hr class="vertical-line" />

      <div>
        <button class="confirm-btn" @click="refreshPage" size="md">
          <span class="vp-font-size-16 btn-text">Okay</span>
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    entityPlan: {
      type: String,
    },
  },
  methods: {
    refreshPage() {
      this.$bvModal.hide("EntityPlanModal");
      // window.location.reload();
    },
  },
};
</script>

<style lang="scss">
#EntityPlanModal___BV_modal_content_ {
  #EntityPlanModal___BV_modal_body_ {
    padding: 40px 42px 24px !important;
  }
   
  border-radius: 26px;
  width: 500px !important;
  div p,
  span {
    color: #4a4a4a;
    margin-bottom: 40px;
  }
  .header-font {
    color: #000000 !important;
    height: 12px;
    line-height: 16px;
  }
  .content {
    letter-spacing: 0.25px;
    line-height: 24px;
    font-weight: 400;
  }
  .confirm-btn {
    width: 112px;
    height: 32px;
    gap: 0px;
    background-color: #103f5e;
    border: none;
    border-radius: 16px;
  }
  .btn-text {
    color: #ffffff;
  }
  .vertical-line {
    border-top: 1px solid #ebebeb;
    margin: 0 0 24px 0;
  }
  .contact_email {
    color: #2680eb;
    text-decoration: underline !important;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: .25px;
  }
}
</style>
